import { registryRecordHref } from './sharedRecordLinks';
export function toMatchCandidates(candidates, hrefKind = 'contact') {
    return (candidates ?? []).filter((c)=>!!c.registryId).slice(0, 5).map((c)=>({
            id: c.registryId,
            name: c.label || 'Unnamed record',
            context: c.detail || undefined,
            evidence: c.basis ? [
                c.basis
            ] : undefined,
            href: hrefKind ? registryRecordHref(hrefKind, c.registryId, '') : undefined
        }));
}
export function resolverCandidates(candidates) {
    return candidates.filter((c)=>!!c.registryId).slice(0, 5).map((c)=>({
            id: c.registryId,
            name: c.name || 'Unnamed record',
            context: c.contextLabel || undefined,
            evidence: c.evidence.length ? [
                ...c.evidence
            ] : undefined,
            readOnlyReference: c.readOnlyReference || undefined
        }));
}
